<template>
  <v-container fluid grid-list-sm>
    <v-card class="pa-3 pt-5">
      <v-layout row wrap class="text-xs-left">
        <v-flex xs12 sm4 class="px-3">
          <v-text-field
            v-model="supplier.accountCode"
            label="Account Code"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 class="px-3">
          <v-text-field
            v-model="supplier.nominalCode"
            label="Sale Nominal Code"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 class="px-3">
          <v-text-field
            v-model="supplier.purchaseNominalCode"
            label="Purchase Nominal Code"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-container class="py-0" fluid>
        <v-row>
          <v-col class="py-0">
            <v-text-field
              label="Accounts Email"
              v-model="supplier.accountsEmail"
              type="email"
              prepend-inner-icon="mdi-email"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col class="py-0">
            <v-text-field
              label="Payee Name"
              v-model="supplier.payeeName"
              prepend-inner-icon="mdi-account"
              :outlined="outlinedInputs"
            ></v-text-field
          ></v-col>
          <v-col class="py-0">
            <payment-method-list-select
              label="Payment Method"
              v-model="supplier.paymentMethod"
              :outlined="outlinedInputs"
              item-text="name"
              item-value="name"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-layout row wrap class="text-xs-left">
        <v-flex xs12 sm12 class="px-3">
          <v-textarea
            label="Cancellation Policy"
            v-model="supplier.cancellationPolicy"
            :outlined="outlinedInputs"
          ></v-textarea>
        </v-flex>
        <v-flex xs12 sm12 class="pa-0">
          <payment-terms v-model="supplier.paymentTerms"></payment-terms>
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout justify-center pt-3>
      <save-btn
        @click="onSave"
        :disabled="$store.getters.hasAccessTo('suppliers:view_only')"
      />
    </v-layout>
  </v-container>
</template>

<script>
import PaymentTerms from "../shared/payment-terms/PaymentTerms";
import PaymentMethodListSelect from "../shared/PaymentMethodListSelect.vue";
import PaymentTypeSelect from "../shared/PaymentTypeSelect.vue";
import SaveBtn from "../shared/SaveButton";
export default {
  name: "SupplierFinancialDetails",
  props: {
    supplier: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    PaymentTerms,
    SaveBtn,
    PaymentTypeSelect,
    PaymentMethodListSelect,
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onSave() {
      this.$emit("onSave");
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/SupplierFinancialDetails.vue